/**
 * Model to handle timezone-list
 */
define('dataSource/timeData',['atn/atn', 'knockout', 'jquery', 'moment', 'lodash'],
    function(atn, ko, $, moment, _) {
        'use strict';
        /**
         * list of timeszones
         * @type {ko.observableArray}
         */
        var timeBoundary = ko.observable();
        var apiFailure = ko.observable();
        var timezoneList = ko.observableArray([]);
        /**
         * observable object for handling errors in loading of timezones
         * @type {ko.observable}
         */
        var errorLoadingTimezones = ko.observable({});

        //the below code clears the observables passed on logout.
        atn.dataCache.addRegistry([timeBoundary, timezoneList, errorLoadingTimezones]);

        return {
            timeBoundary: timeBoundary,
            getLatestDbTimeBoundary: getLatestDbTimeBoundary,
            apiFailure: apiFailure,
            timezoneList: timezoneList,
            errorLoadingTimezones: errorLoadingTimezones,
            getTimezoneList: getTimezoneList
        };
        /**
         * function to get list of timezones
         * @param  {boolean} reload        is reload required?
         * @return {jquery.promise}        promise for getting list of timezone
         */
        function getLatestDbTimeBoundary(reload) {
            return (reload || !timeBoundary()) ? fetchLatestDbTimeBoundary() : atn.utils.dummySuccessDeferred();
        }

        /**
         * fetches the latest list of timezones into timezoneList
         * @return {promise} promise object for fetching timezoneList
         */
        function fetchLatestDbTimeBoundary() {
            timeBoundary();

            var deferred = $.Deferred();

            var queryObject = {
                queryType: 'timeBoundary',
                dataSource: 'babbage',
                bound: 'maxTime'
            };

            var ajaxPromise;
            apiFailure(false);
            ajaxPromise = $.ajax({
                url: atn.config.api.analytics,
                data: JSON.stringify(queryObject),
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json'
            }).done(function(response){
                if(response[0]){
                    timeBoundary(moment(response[0].result.maxTime).toISOString());
                }
                else {
                    timeBoundary(moment().utc().toISOString());
                }
                deferred.resolve(response);
            }).fail(function(xhr){
                deferred.reject(xhr);
                apiFailure(true);
            });

            return deferred.promise();
        }

        /**
         * function to get list of timezones
         * @param  {boolean} reload        is reload required?
         * @return {jquery.promise}        promise for getting list of timezone
         */
        function getTimezoneList(reload) {
            return (reload || !timezoneList().length) ? fetchTimezoneList() : atn.utils.dummySuccessDeferred();
        }

        /**
         * fetches the latest list of timezones into timezoneList
         * @return {promise} promise object for fetching timezoneList
         */
        function fetchTimezoneList() {
            var promise,
                deferred = $.Deferred();
            timezoneList([]);
            promise = atn.rest.get(
                atn.config.api.timezones,
                'supportedTimezones',
                timezoneList,
                errorLoadingTimezones,
                modifyTimeZoneModelList
            );

            promise.done(function(response){
                deferred.resolve(response);
            });

            promise.fail(function(xhr){
                deferred.reject(xhr);
            });

            return deferred.promise();
        }

        function modifyTimeZoneModelList(timezonesList){
            var retObj = [];
            retObj = _.sortBy(_.map(timezonesList, function(timezone){
                return {
                    value: timezone.id,
                    offset: timezone.offset,
                    text: timezone.id + ' ('+ atn.utils.convertMilliSecsToTzOffsetStr(timezone.offset) + ')',
                    offsetStr: atn.utils.convertMilliSecsToTzOffsetStr(timezone.offset)
                };
            }), ['offset']);
            return retObj;
        }
    });
